import React from "react";


import { Grid } from "@material-ui/core";
import AddIcon from '@mui/icons-material/Add';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import LoadingButton from '@mui/lab/LoadingButton';
import Card from "@material-ui/core/Card";
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import Style from "../../../../styles/js/Styles";
import * as Constants from "../../../../consts/Constants.js";
import alerter from "../../../alerts/alerter"
import Image from "../../../utils/image"
import ImageViewer from "../../../utils/image-viewer"
import service from '../../../../plas/map/places/service.jsx';
import { createByteArray } from "../../../../plas/utils";

export default function Photos({ place, disable }) {

  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFFFFF',
        darker: '#FFFFFF',
      }
    },
  });

  const style = Style();

  const [uploading, setUploading] = React.useState(false)
  const [removing, setRemoving] = React.useState(false)
  const [selectedImage, setSelectedImage] = React.useState(null)
  const inputFile = React.useRef(null)

  const onButtonClick = () => {
    inputFile.current.click();
  }

  const onSelectFile = (event) => {
    event.stopPropagation();
    event.preventDefault();

    const file = event.target.files[0];

    if (file) {
      uploadPhoto(file);
    }
  }

  const uploadPhoto = (file) => {
    setUploading(true);

    const bin = {
      name: file.name,
      type: file.type,
      data: createByteArray(URL.createObjectURL(file))
    };

    service.api.placePhotos.create(place.id, bin, {
      onUpdateProgress: (progressValue) => { },
      result: (response) => {
        if (response.result != null) {
          place.addPhoto(response.result);
        } else {
          alerter.showError(response.error);
        }
        setUploading(false);
      }
    })
  }

  const deletePhoto = (photo) => {
    setRemoving(true);

    service.api.placePhotos.delete(photo.placeId, photo.id, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        place.removePhoto(photo);
      }
      setRemoving(false);
    })
  }

  const showImage = (image, url) => {
    if (url) { // Puede que todavía no este cargada la img y la url sea undefined
      setSelectedImage(url)
    }
  }

  const closeImage = () => {
    setSelectedImage(null)
  }

  return (
      <Grid container spacing={2} >
        <Grid item xs={12}>
          { place.photos.length !== 0 ? (
            <Card elevation={0}>
              <ImageList
                sx={{ maxHeight: 300}}
                style={{
                  background: Constants.COLOR_GRAY_ULTRA_LIGHT,
                  padding: '6px'
                }}
                cols={5}
                variant="standard"
                rowHeight={'140'}>
                {place.photos.map((image) => (
                  <ImageListItem key={image.id} style={{ justifyContent: 'center'}} >
                    <Image
                      url={service.api.placePhotos.url(image)}
                      onClick={(url) => { showImage(image, url) }}
                      containerProps={{
                        className: style.imgListItem,
                      }}
                      imgProps={{ className: style.imgListItemSelectable }}
                    />
                    <ImageListItemBar
                      actionIcon={
                        <IconButton disable={removing} sx={{ color: 'rgba(255, 255, 255, 0.54)' }} onClick={() => deletePhoto(image)}>
                          <DeleteOutlineIcon fontSize={"small"}/>
                        </IconButton>
                      }
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </Card>) : null
          }
        </Grid>
        <Grid item xs={true} />
        <Grid item xs={'auto'}>
            <ThemeProvider theme={theme}>
              <LoadingButton
                style={{height: '100%'}}
                loading={uploading}
                disabled={disable || removing}
                startIcon={<AddIcon/>}
                loadingPosition="start"
                variant="contained"
                fullWidth
                onClick={onButtonClick}>
                <input type='file' accept="image/*" id='file' ref={inputFile} style={{display: 'none'}} onChange={ (event) => onSelectFile(event) }/>
              <b>Agregar</b>
            </LoadingButton>
          </ThemeProvider>
        </Grid>
        <ImageViewer open={selectedImage} url={selectedImage} onClose={closeImage} />
      </Grid>

  );
}
